import { IInitialMetaState } from 'interfaces/meta.interface';
import { handleSftp } from './metaSftp/metaSftp.reducer';
import { handleShopify } from './metaShopify/metaShopify.reducer';
import { handleMapFields } from './metaMapFields/metaMapFields.reducer';
import { handleMappings } from './metaMappings/metaMappings.reducer';
import {
  handleMetaConnections,
  TMetaConnectionsDispatchReducer,
} from './metaConnections/metaConnections.reducer';

export default function metaReducer(state: IInitialMetaState, action: any) {
  state = handleMetaConnections(state, action as TMetaConnectionsDispatchReducer);
  state = handleSftp(state, action);
  state = handleShopify(state, action);
  state = handleMappings(state, action);
  state = handleMapFields(state, action);

  return state;
}
